import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

export function useInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(
    () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
  );

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const promptInstall = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === 'accepted') { setInstalled(true); setDeferred(null); return true; }
    return false;
  };

  return { canInstall: !!deferred && !installed, installed, promptInstall };
}

export function InstallButton({ className = '', testId = 'install-app-btn' }) {
  const { canInstall, promptInstall } = useInstallPrompt();
  if (!canInstall) return null;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={promptInstall}
      className={`flex items-center justify-center gap-1.5 rounded-sm bg-kelate-darkwood px-3 py-1.5 text-sm font-medium text-kelate-surface hover:opacity-90 ${className}`}
    >
      <Download size={14} /> Install App
    </button>
  );
}
